// Called by : src/App.vue (router-view)

<template>
  <div id="page_validation">

    {{ forceUpdate }}

    <h1 id="page_patience_title" class="page_title mb-4 px-2">
      {{ $t('valid.title') }}
    </h1>

    <div id="cardcont" class="valid card">

      <div id="cardcont_tete" class="card-header h2 text-white text-center txt_ombre_333">
        {{ $t('valid.formTitle') }}
      </div> <!-- #cardcont_tete -->

      <div id="cardcont_corps" class="card-body" style="font-size: 1.2em;">
          
        <div id="cardcont_form" class="form">

          <div class="form-row px-sm-4">

            <div class="form-group col-md-5 mb-0">
              <p class="mb-0">
                <span class="text-muted mr-2">{{ $t('valid.user') }}</span>
                <span class="text-dark font-weight-bold">{{ user.fullName }}</span>
              </p>
            </div>

            <div class="form-group col-md-7 mb-0">
              <p class="mb-0">
                <span class="text-muted mr-2">{{ $t('valid.lesson') }}</span>
                <span class="text-dark font-weight-bold">{{ lesson.name }}</span>
              </p>
            </div>

          </div> <!-- .form-row -->

          <hr>

          <div class="form-row px-sm-4">

            <div class="form-group col-md-5 mb-0">
              <p class="text-muted mb-0">{{ $t('valid.coachValidation') }}
                <span class="ml-1 text-danger">*</span>
              </p>

              <div class="form_radio form-check form-check-inline mt-0 ml-0 mr-3">
                <label class="form_radio_label font-weight-bold text-uppercase text-success " for="valid_yes">
                  <input type="radio" id="valid_yes" name="validation" class="form_radio_input valid_yes" value="1" required="required" v-model="validate" checked="checked">
                  <span class="form_radio_icon"><b></b></span>
                  {{ $t('common.yes') }}
                </label>
              </div>

              <div class="form_radio form-check form-check-inline mt-0 ml-0 mr-3">
                <label class="form_radio_label font-weight-bold text-uppercase text-danger " for="valid_no">
                  <input type="radio" id="valid_no" name="validation" class="form_radio_input valid_no" value="0" required="required" v-model="validate">
                  <span class="form_radio_icon"><b></b></span>
                  {{ $t('common.no') }}
                </label>
              </div>
            </div>

            <div class="form-group col-md-7 mb-0">
              <label class="text-muted mb-2 w-100" for="valid_phone">
                {{ $t('valid.coachPhone') }}
                <span class="ml-1 text-danger">*</span>
              </label>
              <input ref="rTel" id="valid_phone" name="valid_phone" type="password" class="form-control" :placeholder="$t('valid.coachPhonePlaceholder')" v-model="phone" @keypress="isNumber" value="" minlength="10" maxlength="14" required="required" autofocus="autofocus">
            </div>

          </div> <!-- .form-row -->

          <div class="form-row px-sm-4">

            <div class="form-group col-md-12 mt-3">
              <label class="text-muted mb-2 w-100" for="valid_comment">
                {{ $t('valid.coachComment') }}
                <span class="ml-1 text-danger">*</span>
              </label>
              <textarea id="valid_comment" name="valid_comment" class="form-control" rows="6" v-model="comment" required="required"></textarea>
            </div>

          </div> <!-- .form-row -->

          <p id="valid_infos" class="alert alert-info mb-0 mt-3" role="alert" style="padding: 5px 10px;">
            <small class="font-weight-bold">
              <span class="mr-1 text-danger">*</span>
              {{ $t('valid.requiredField') }}
            </small>
          </p>
          <p id="valid_error" class="alert alert-danger mb-0" role="alert" style="display: none;">
            {{ errors }}
          </p>

        </div> <!-- #cardcont_form -->

      </div> <!-- #cardcont_corps -->

      <div id="cardcont_pied" class="card-footer">

        <div class="btn-group-vertical d-inline-flex d-md-none w-100">
          <button type="reset" class="btn btn-secondary btn-lg" @click="close">
            <span class="oi oi-ban mr-2"></span>
            {{ $t('modals.cancel') }}
          </button>
          <button type="submit" class="btn btn-primary btn-lg" @click="saveAndClose" :disabled="getDisabled()">
            <span class="oi oi-check mr-2"></span>
            {{ $t('valid.saveEvaluation') }}
          </button>
        </div>

        <div class="btn-group d-none d-md-inline-flex w-100">
          <button type="reset" class="btn btn-secondary btn-lg" @click="close" style="width:30%;">
            <span class="oi oi-ban mr-2"></span>
            {{ $t('modals.cancel') }}
          </button>
          <button type="submit" class="btn_page_submit btn btn-primary btn-lg" @click="saveAndClose" :disabled="getDisabled()" style="width:70%;">
            <span class="oi oi-check mr-2"></span>
            {{ $t('valid.saveEvaluation') }}
          </button>
        </div>

      </div> <!-- #cardcont_pied -->

    </div> <!-- #cardcont -->

    {{ forceRefresh }}

  </div> <!-- #page_validation -->
</template>

<script>
import BaseModal from '@/components/BaseModal'

export default {
  components: {
    BaseModal,
  },
  data() {
    return {
      validate: 1,
      phone: '',
      comment: '',
      errors: '',
    }
  },
  methods: {
    getDisabled() {
      let bOff = Boolean(!this.phone || !this.comment);
      f_setPageBtnOff_v(bOff);
      return bOff;
    },
    isNumber(event) {
      const charCode = event.keyCode
      if ((charCode >= 48) && (charCode <= 57 )) {
        return true
      } else {
        event.preventDefault()
      }
    },
    close() {
      // this.$router.go(-1)
      this.$router.push({ name: 'assignments' });
    },
    saveAndClose() {
      this.model.runScript(
        'VAL_js',
        '2022_VUEJS_Validation_Set',
        this.user.zkp + '|' +
        this.lesson.zkp + '|' +
        this.lesson.zkf_sta + '|' +
        this.lesson.zkf_ses + '|' +
        this.validate + '|' +
        this.phone + '|' +
        f_setReplaceEol_s(this.comment)
      )
      // bascule vers "Patience.vue"
      var oParams = {
        sTitlePage: this.$t('valid.title'),
        sTextHeader: null,
        sTextFooter: null,
        nTimeout: this.params.patienceTime,
        sRouteName: null,
      };
      this.$router.push({ name: 'patience', params: oParams});
      // this.close()
    },
  },
  mounted: function() {
    this.$refs.rTel.focus();
  },
  computed: {
    phoneOk() {
      return (this.phone.length >= 10) && (this.phone.length <= 14)
    },
    params() {
      return this.$store.state.params
    },  
    model() {
      return this.$store.state.model
    },
    user() {
      return this.$route.params.user
    },
    lesson() {
      return this.$route.params.lesson
    },
    forceUpdate() {
      return '';
    },
    forceRefresh() {
      return '';
    },
  },
}
</script>

<style scoped>
div.form_radio {
  transform: scale(0.902); /* 110% */
}
label.form_radio_label {
  color: #000;
  cursor: pointer;
  position: relative;
  font-size: 1.6rem;
  line-height: 1.2em;
  padding-left: 44px;
  text-indent: -44px;
}
label.form_radio_label_audio {
  padding-left: 96px;
  text-indent: -96px;
}
input.form_radio_input {
  display: none;
}
span.form_radio_icon,
span.form_radio_icon > b {
  display: inline-block;
  box-sizing: border-box;
  border-radius: 50%;
  cursor: pointer;
}
span.form_radio_icon {
  width: 34px;
  height: 34px;
  margin: 0 0.25rem 0 0;
  border: 5px solid #888;
  background-color: #fff;
  position: relative;
  top: 0.5rem;
  text-indent: 0;
}
span.form_radio_icon > b {
  width: 24px;
  height: 24px;
  border: 5px solid #fff;
  background-color: #fff;
  position: absolute;
  top: 0;
}
label.form_radio_label:hover > span.form_radio_icon,
span.form_radio_icon:hover {
  box-shadow: 2px 2px 4px #bbb;
}
label.form_radio_label:active > span.form_radio_icon,
span.form_radio_icon:active {
  border-color: #000;
  box-shadow: none;
}
label.form_radio_label:hover > span.form_radio_icon > b,
span.form_radio_icon:hover > b,
span.form_radio_icon > b:hover {
  background-color: #000;
  opacity: 0.5;
}
label.form_radio_label:active > span.form_radio_icon > b,
span.form_radio_icon:active > b,
span.form_radio_icon > b:active {
  background-color: #000;
  opacity: 1;
}
input.form_radio_input:checked + span.form_radio_icon {
  border-color: #000;
  box-shadow: none;
}
input.form_radio_input:checked + span.form_radio_icon > b {
  background-color: #06c;
  opacity: 1;
}
input.form_radio_input.valid_yes:checked + span.form_radio_icon > b {
  background-color: #2a4;
}
input.form_radio_input.valid_no:checked + span.form_radio_icon > b {
  background-color: #d34;
}
/*
#28a745 = success = #3b4 - #2a4
#dc3545 = danger = #e34 - #d34
*/
</style>



// WEBPACK FOOTER //
// src/components/lesson/CoachValidation.vue